var _circle, _path, _path2, _path3, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.001,
    cy: 16,
    r: 16,
    fill: "#F5F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0177 8.42499C13.2593 8.42499 11.0177 10.6667 11.0177 13.425V15.8333C11.0177 16.3417 10.801 17.1167 10.5427 17.55L9.58432 19.1417C8.99266 20.125 9.40099 21.2167 10.4843 21.5833C14.076 22.7833 17.951 22.7833 21.5427 21.5833C22.551 21.25 22.9927 20.0583 22.4427 19.1417L21.4843 17.55C21.2343 17.1167 21.0177 16.3417 21.0177 15.8333V13.425C21.0177 10.675 18.7677 8.42499 16.0177 8.42499Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5593 8.66667C17.301 8.59167 17.0343 8.53334 16.7593 8.5C15.9593 8.4 15.1926 8.45834 14.476 8.66667C14.7176 8.05 15.3176 7.61667 16.0176 7.61667C16.7176 7.61667 17.3176 8.05 17.5593 8.66667Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5176 21.8833C18.5176 23.2583 17.3926 24.3833 16.0176 24.3833C15.3343 24.3833 14.701 24.1 14.251 23.65C13.801 23.2 13.5176 22.5667 13.5176 21.8833",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.001,
    cy: 10,
    r: 3,
    fill: "#5444F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a3ca05109fd723d6372dfb96957d051a.svg";
export { ForwardRef as ReactComponent };